import React from "react";
import EmptyIcon from "@/assets/icons/web_asset_off.svg?react";

type PlotConflictWarningProps = {
  conflicts: string[];
  columnsTitleCreator?: (column: string) => string;
};

export const PlotConflictWarning: React.FC<PlotConflictWarningProps> = ({
  conflicts,
  columnsTitleCreator,
}) => {
  return (
    <div className="absolute top-16 left-0 right-0 bottom-0 bg-white flex flex-col items-center justify-center z-10 rounded-b-lg">
      <div className="text-center p-6">
        <div className="flex justify-center mb-4">
          <EmptyIcon />
        </div>
        <h3 className="text-lg font-semibold text-[#2B4752] mb-2">
          Warning! You have an empty plot
        </h3>
        <p className="text-gray-600 mb-4 max-w-md">
          Global and Plot filters have no overlap for the following filters:
        </p>
        <div className="flex flex-wrap justify-center gap-2 text-sm text-[#064C68]">
          {conflicts.map((conflict) => (
            <div
              key={conflict}
              className="bg-[#ECFAFF] px-3 py-1 rounded-full text-xs inline-block font-medium"
            >
              {columnsTitleCreator ? columnsTitleCreator(conflict) : conflict}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
